export default {
  getProformaById: state => id => {
    return state.proformas.find((p) => p._id === id)
  }
}
